import React, { useState, useEffect, useContext } from "react";
import { useHistory} from "react-router-dom";
import { Formik } from "formik";
import InputTxt from "../framework/InputTxt";
import Button from "../framework/Button";
import Ribbon from "../framework/Ribbon";
import webRootContext from "../components/webrootcontext/WebRootContext";
import { AppConfiguration } from "../framework/AppConfigProvider";
import { USER_OBJECT } from "../components/UserObject";
import { UserProfile } from "../components/UserProfileProvider";   /* Need to override UserProfile */

function Login(props) {
 	const [saveSuccess, setSaveSuccess] = useState(false);
	const [saveFailed, setSaveFailed] = useState();    
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [responseError, setResponseError] = useState();
	const localConfig = useContext(AppConfiguration);
	const [userObject, setUserObject] = useState(USER_OBJECT);


  //Retrieve and display user profile info from the context.
  	const currentContext = useContext(UserProfile);
  	
  	// use for add remove class for login layout
  	//const [hasClass] = useState(true);

	// Setup History path
	const history = useHistory();  
    const obsLogoImg = "BCH_observershipLogos.png"; //no need to import public folder image file
          
	let url = webRootContext + "/rest/usermanagement/login";
	const resetPwdUrl = webRootContext + "/ForgotPassword";
	
	const checkKeyDown = (e) => {
		if (e.key === 'Enter') e.preventDefault();
	}
	
	function validateEmail(checkemail){
		let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/; // eslint-disable-line

		return reg.test(checkemail.trim());
	}
	
	function navToCreateAccount(e){
        e.preventDefault();
    	window.location.href = webRootContext + "/CreateAccount";
    	
  }
  
  
	useEffect(() => {		
		props.updateTitle({"long":localConfig.configProperties.applicationName,"short":localConfig.configProperties.applicationNameAbbrev});	
		
		const articleElement = document.querySelector('article');
		    if (articleElement) {
		      articleElement.classList.add('article-observership');
		    }
		
		const headerElement = document.querySelector('.header');
			if(headerElement){
		      headerElement.classList.add('header-observership');
		    }
		
		const headermenuBarElement = document.querySelector('.header__menuBar');
		    if (headermenuBarElement) {
		      headermenuBarElement.classList.add('header__menuBar-observership');
		    }
		
		const BCHAppElement = document.querySelector('.BCHApp');
			if(BCHAppElement){
		      BCHAppElement.classList.add('BCHApp-observership');
		    }
		    
		const footerElement = document.querySelector('.footer');
			if (footerElement) {
	            footerElement.style.marginTop = '0px';
	        }
		
		return () => {
	      if (articleElement) {
	        articleElement.classList.remove('article-observership');
	      }
	      
	      if(headerElement){
		      headerElement.classList.remove('header-observership');
		    }
		
		    if (headermenuBarElement) {
		      headermenuBarElement.classList.remove('header__menuBar-observership');
		    }
		
			if(BCHAppElement){
		      BCHAppElement.classList.remove('BCHApp-observership');
		    }
		    
		    if (footerElement) {
	            footerElement.style.marginTop = '30px';
	        }
		    
    	};
    			
	},[props, localConfig]); // eslint-disable-line
    	  
	const accNotFoundErrMsgContent =  <div>
		<span className="error-message--large">Sorry, we could not find an account with that username and password.</span>
     	<br />
        <div className="first-level">Double-check your entry and try again</div>
		<div className="first-level"><a href="./ForgotPassword">Forgot your password?</a></div>
		<div className="first-level"><a href="./CreateAccount">Create an account</a></div>		
	</div>; 
	             
	const accNotActivatedErrMsgContent =  <div>
		<span className="error-message--large"> Your account has not been activated yet.</span>
     	<br />
        <div> Please activate your account by clicking the link provided in the email.</div>	  
    </div>; 
    const errLoginMsgContent = <div><span className="error-message">Sorry, there is a problem on our end.</span></div>

   //Log the user in
   function loginUser(values) {
     if(saveFailed === false){return;}
   	   
	 fetch(url, {
     	method: 'POST', 
   		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(values), mode:"cors"})
	 	.then((response) => {	 
			if(response.ok) {
				setSaveSuccess(true);
		    	setSaveFailed(false);
  				// Set Authenticated in userProfile to true
  				currentContext.userProfile.authenticated = true;
  				console.log("Called Login User - setting isLoggedIn true");
				sessionStorage.setItem("isLoggedIn", true);
  				
		    	return response.json();
			} else {         	   		      	   
                currentContext.userProfile.authenticated = false;
				sessionStorage.setItem("isLoggedIn", false);
        		let errorStatusCode =  response.headers.get("ERROR");  
        		if(errorStatusCode === '3') {
              		setResponseError(accNotActivatedErrMsgContent);
            	} else if (errorStatusCode === '4' || errorStatusCode === '0') {
              		setResponseError(accNotFoundErrMsgContent);
            	} else {
                	setResponseError(errLoginMsgContent);
                }             
                           
	              //redirect to force reset password
	              if (response.status === 460 || errorStatusCode === "RESET PASSWORD") {   
                        history.push({
					        pathname: resetPwdUrl,
					        state: { data: "FORCEPWD" },   //make sure email exists for this
				      	}); 
                            	                  
			      	   
	               }
	                      		
				  setSaveSuccess(false);
		    	  setSaveFailed(true);
		    		
		    	  return Promise.reject(errorStatusCode);	 
		   }		
	 	})        
		.then(
	        (result) => {              	
				currentContext.userProfile.firstName = result.firstName;
				currentContext.userProfile.lastName = result.lastName;
				currentContext.userProfile.email = result.email;
				currentContext.userProfile.country = result.country;
	        	setUserObject(result); 
	        	console.log("Current Context:", currentContext.userProfile);
	        	
  		        // path to forward to the applicant dashboard
		        history.push({
			        pathname: '/observership/',
			        state: { data: result },   
		      	});
         })
 		.catch((err) => {
          	console.log("error", err); 
	  	});
  	
	};
	
	
  return (
    <>
      <div className="background-image">
      <div class="header__title-observership">Application & Registration Portal</div>
        <Formik 
		 	initialValues={{
			 	"email": "",
			   	"password": ""
			   
			 }}
			 
			 validate={values => {
         		const errors = {};
         		setFormikError(false);
                
         		
         		if (userObject) {
		             if (userObject.email) {
		                    values.email = userObject.email;
		             }
		             
		             if (userObject.password) {
		                    values.password = userObject.password;
		             }
		             
		             //Validate form fields 
		                     
			         let emailErrorMsg = 'Enter a valid email address using this format: example@mail.com';	         
			         if (!values.email) {
			            errors.email = 'Email address is required';
			         } else if ((values.email) && (!validateEmail(values.email))) {
						errors.email = emailErrorMsg;  
					 }
			         if (!values.password) {
			           	 errors.password = "Password is required";
			         }
		         }
         		
		         if( Object.keys(errors).length > 0) {
					setFormikError(true);
				  } else {
		              setFormikError(false);
		          }	
		         return errors;
		       }}
			
			onSubmit={(values, { setSubmitting }) => {
		          setTimeout(() => {
					  	loginUser(values);
		          		setSubmitting(false);
		          }, 1);
		        }}
			 >
          {({
            values /* all data need to run the valdation*/,
            errors /* all error strings */,
            touched /* all field touch event  */,
            handleChange /* value change event handler */,
            handleBlur /* onBlur event handler */,
            handleSubmit /* for submit button */,
            isSubmitting /* for submit button */,
            isValid /* for submit button */,
            dirty /* for submit button */,
            validateForm,
            /* and other goodies */
          }) => (
          <form onSubmit={handleSubmit}  onKeyDown={(e) => checkKeyDown(e)} noValidate>
          
      		<div className="div_3_col padding-top-30 dashboard__alignRight">
				<img src={obsLogoImg} alt="obsLogoImg" />
			</div>				
         	<br /><br />
				    		
			<div id="submitFailed" className={(saveFailed ? 'show_div' : 'hide_div')}>
				<div id="failDiv" className="div_1_col">
					<Ribbon label={"ERROR"} status={"error"} subheader={""}  content={responseError} />
				</div>
			</div>
			
			<div id="formikErrors" className={(formikError && formSubmitted? 'show_div' : 'hide_div')}>
                <div id="formikFailDiv" className="div_1_col">
               		<Ribbon label={"REVIEW ISSUES BELOW"} status={"error"} subheader={""} content={""} />
               </div>
            </div>
           
            
            <div className={(saveSuccess ? 'hide_div' : 'show_div' )}>
             	
            	<div id="theDiv3Hide5" className="div_3_col">
                  <div>
                    <InputTxt
		                id="email" // need match value name
		                name="email" // name will not work for formik in this case for input box
		                labelText={"Email Address"}
		                isRequired={true}
		                maxLength={100}               
		                // show error and error message is control by formik    
		                errorMessage={errors.email}         
		                hasError={touched.email && errors.email}               
		                // onchange and onblur is return event, handle by formik
		                onChange={handleChange}
		                onBlur={handleBlur}
		                // setup formik value
		                value={userObject.email}
		                getTextString={(email) => setUserObject({...userObject, email: email.trim()})}
		              />
                  </div>
                  <div>
                    <InputTxt
		                id="password" // need match value name
		                name="password" // name will not work for formik in this case for input box
		                labelText={"Password"}
		                isRequired={true}
		                maxLength={150}               
		                type="password"
		                // show error and error message is control by formik    
		                errorMessage={errors.password}      
		                hasError={touched.password && errors.password}               
		                // onchange and onblur is return event, handle by formik
		                onChange={handleChange}
		                onBlur={handleBlur}
		                // setup formik value
		                value={userObject.password}
		                getTextString={(password) => setUserObject({...userObject, password: password.trim()})}
		              />
                  </div>  
                </div>
             
                <div className="div_3_col padding-bottom-30">
		          <Button
		                text={"LOGIN"}
		                styleName={"button button--primary ql-text-editor"}
		                id={"button_submit"}
		                type="submit"
		               onClick={(e) =>{setFormSubmitted(true); validateForm();               
		                }}
		          />
                </div>
                
                <div className="div_3_col">
		        	<div className="padding-bottom-30"><a href="./ForgotPassword">Reset/Forgot Password</a></div>
                </div>
                
                <hr className="hr--light" />
                
		        <div className="div_3_col">
		        	<h3 className="color--boston-pink padding-bottom-20">New Users</h3>
		           	<div className="padding-bottom-30">		           		
		           		<Button 
		           		    type="button"
		           			text={"Create Account"} 
		           			styleName={"button button--special ql-text-editor"}
		           			id={"button_createaccount"}
		           			onClick={(e) => {navToCreateAccount(e);}} />
		           	</div>
		            <div className="padding-bottom-30"><a href="./RequestActivateToken">Request new activation code</a></div>
                </div>	
		        		         	 	
            </div>
            
          </form>
          )}
        </Formik>
        
      </div>
    </>
  );
}

export default Login;

